import { render, staticRenderFns } from "./ListBill.vue?vue&type=template&id=2659f0e0&"
import script from "./ListBill.vue?vue&type=script&lang=ts&"
export * from "./ListBill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports